import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Home, Send, Clock, User, Star } from 'lucide-react';
import { BRAND } from '../brand';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const tabs = [
    { icon: Home, label: 'Inicio', path: '/dashboard' },
    { icon: Send, label: 'Enviar', path: '/send-money' },
    ...((BRAND?.features?.gbPuntos && BRAND?.puntosProgramName) ? [{ icon: Star, label: 'Puntos', path: '/gb-puntos' }] : []),
    { icon: Clock, label: 'Historial', path: '/transactions' },
    { icon: User, label: 'Perfil', path: '/profile' },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') return location.pathname === '/dashboard' || location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 safe-area-bottom"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="bottom-nav"
    >
      <div className="max-w-md mx-auto flex items-center justify-around h-16">
        {tabs.map(({ icon: Icon, label, path }) => {
          const active = isActive(path);
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
                active ? 'text-green-700' : 'text-slate-400 hover:text-slate-600'
              }`}
              data-testid={`nav-${label.toLowerCase()}`}
            >
              <Icon size={22} strokeWidth={active ? 2.2 : 1.5} />
              <span className={`text-[10px] font-medium ${active ? 'font-semibold' : ''}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
